import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RedirectComponent } from './shared/redirect/redirect.component';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
    { path: 'signin', component: LoginComponent }, // Route for the login page
    { path: '', redirectTo: 'signin', pathMatch: 'full' }, // Redirect root to login
    { path: 'cims', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'signin' }, // Wildcard route for invalid paths
    { path: 'cims/redirect', component: RedirectComponent, canActivate: [AuthGuard] },
];
